import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { SavedSearch } from '../models/review/saved-search.model';
import { QuickLinkUpdate } from '../components/review/quick-links/quick-link-update';
import { UserConfigsService } from 'src/app/services/user-configs.service';

@Injectable({
	providedIn: 'root'
})
export class SavedSearchesService implements QuickLinkUpdate {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService, private userConfigsService: UserConfigsService) { }

	getAll(): Observable<SavedSearch[]> {
		return this.http.get<SavedSearch[]>(`${this.appConfigService.getConfig().webApi}/api2/savedsearches`)
			.pipe(catchError(this.errorHandler.handleError<SavedSearch[]>(`get saved searches`)));
	}

	getRecentQueries(prefix: string): Observable<string[]> {
		if (prefix === null || prefix === undefined)
			prefix = '';
		const params = new HttpParams().set('prefix', prefix);
		return this.http.get<string[]>(`${this.appConfigService.getConfig().webApi}/api2/SavedSearchesAutocomplete`, { params: params })
			.pipe(catchError(this.errorHandler.handleError<string[]>(`get recent queries`)));
	}

	updateLink(savedSearch: SavedSearch): Observable<any> {
		return this.http.put(`${this.appConfigService.getConfig().webApi}/api2/savedsearches/${savedSearch.searchId}`, savedSearch)
			.pipe(catchError(this.errorHandler.handleError<SavedSearch>(`[PUT] savedsearches failed for searchId=${savedSearch.searchId}`)));
	}
}
